import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'error-message',
    template: `
  
  <div style="display:flex"><img src="assets/img/error.svg" class="me-2">{{data}}</div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorMessageComponent {
   constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string){

   }
}